import firebase from 'firebase';
import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/database';

import { APP_CONFIG } from './secureFirebase';

class Firebase {
  auth: firebase.auth.Auth;
  storage: firebase.storage.Storage;
  database: firebase.database.Database;
  persistence: typeof firebase.auth.Auth.Persistence;

  constructor() {
    if (!app.apps.length) {
      app.initializeApp(APP_CONFIG);
    } 
    this.auth = app.auth();
    this.storage = app.storage();
    this.database = app.database();
    this.persistence = firebase.auth.Auth.Persistence;
  }
}

export default Firebase;
